// extracted by mini-css-extract-plugin
export default {"component":"btIFlL","image":"ctIFlL","title":"dtIFlL","subtitle":"etIFlL"};